/* ===========================================================================
 * 08 Left - Customize  (custom-changes popup)
 * ---------------------------------------------------------------------------
 * A "Customize" button opens a popup to request a color / text / orientation /
 * version (White Line / Raw Metal) change on a print. The customer's
 * instructions are captured in the popup and
 * attached to the order as Shopify line-item PROPERTIES on the change product,
 * so the merchant sees exactly what to proof - no email back-and-forth.
 *
 * Pure theme JS, no backend. Members get color/text free via Conjured's
 * checkout discount (untouched here). Color change is hidden on Limited
 * Edition / Heavy / Limited Metal pieces.
 *
 * Trigger: any element with class "ol-customize-btn". Optional data attributes
 * carry product context (added by the Liquid block):
 *   data-product-title, data-product-tags, data-product-handle
 *
 * Pure ASCII (special chars as HTML entities) so a paste can't corrupt it.
 * ======================================================================== */
(function () {
  "use strict";
  if (window.__olCustomizeLoaded) return;
  window.__olCustomizeLoaded = true;

  var VERSION = "2026-07-20.1";
  console.log("%c[08L customize] " + VERSION, "color:#0a0a0a;background:#f9cb0c;padding:2px 6px;border-radius:3px;font-weight:700");

  var INK = "#0a0a0a", YELLOW = "#f9cb0c", RED = "#c42126";
  var FONT = '"proxima-nova","Proxima Nova",-apple-system,BlinkMacSystemFont,"Helvetica Neue",Helvetica,Arial,sans-serif';

  // The change products (variant ids + prices in cents).
  var CHANGES = {
    color:  { vid: 20253450600536, price: 499, label: "Color change", excludeLimited: true },
    text:   { vid: 20253460299864, price: 249, label: "Text + design change" },
    orient: { vid: 20253453582424, price: 0,   label: "Diagram orientation" },
    version:{ vid: 10418451480898, price: 0,   label: "Version change" }
  };

  var state = { open: false, cssDone: false };

  function money(c) { return c === 0 ? "Free" : "$" + (c / 100).toFixed(2).replace(/\.00$/, ""); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function isLimited(ctx) {
    return /limited|heav|no-customize/i.test((ctx.tags || "") + " " + (ctx.title || ""));
  }
  function isMember(ctx) { return ctx.member === "1" || ctx.member === "true"; }
  // Members (annual-first / lifetime-first) get color + text free via Conjured.
  function priceLabel(key, ctx) {
    var cfg = CHANGES[key];
    if (cfg.price === 0) return "Free";
    if (isMember(ctx) && (key === "color" || key === "text")) return "Free";
    return money(cfg.price);
  }
  var PERKS_URL = "https://08left.com/pages/08l-first-class-perks";
  // Members see this; non-members get a nudge linking to the perks page.
  function memberNote(ctx) {
    if (isMember(ctx)) return "Free with your membership &mdash; applied at checkout.";
    return 'Color &amp; text changes are free for <a href="' + PERKS_URL + '" target="_blank" rel="noopener" style="color:inherit;font-weight:700;text-decoration:underline">members</a>.';
  }

  // ---- styles ------------------------------------------------------------
  function injectCSS() {
    if (state.cssDone) return; state.cssDone = true;
    var c = ""
      + ".olc-overlay{position:fixed;inset:0;background:rgba(10,10,10,.55);display:flex;align-items:center;justify-content:center;z-index:999999;padding:18px;font-family:" + FONT + ";-webkit-font-smoothing:antialiased;opacity:0;transition:opacity .18s;overflow-y:auto}"
      + ".olc-overlay.in{opacity:1}"
      + ".olc-modal{background:#fff;color:" + INK + ";width:100%;max-width:560px;border:1.5px solid " + INK + ";border-radius:12px;padding:30px 30px 26px;position:relative;transform:translateY(8px);transition:transform .18s;box-sizing:border-box;margin:auto}"
      + ".olc-overlay.in .olc-modal{transform:none}"
      + ".olc-modal *{box-sizing:border-box}"
      + ".olc-close{position:absolute;top:10px;right:13px;background:none;border:0;font-size:27px;line-height:1;cursor:pointer;color:" + INK + ";opacity:.5}"
      + ".olc-close:hover{opacity:1}"
      + ".olc-eyebrow{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:700;opacity:.55;margin-bottom:6px}"
      + ".olc-h{font-size:25px;font-weight:800;letter-spacing:-.4px;margin:0 0 4px;line-height:1.12}"
      + ".olc-for{font-size:13px;opacity:.6;margin:0 0 20px}"
      + ".olc-types{display:flex;flex-direction:column;gap:10px;margin-bottom:6px}"
      + ".olc-type{display:flex;align-items:center;justify-content:space-between;gap:14px;text-align:left;font:inherit;background:#fff;border:1.5px solid " + INK + ";border-radius:8px;padding:16px 20px;cursor:pointer;transition:background .12s}"
      + ".olc-type:hover{background:" + YELLOW + "}"
      + ".olc-type .tw{display:flex;flex-direction:column;gap:3px;text-align:left}"
      + ".olc-type .t{display:block;font-size:15px;font-weight:700;line-height:1.2}"
      + ".olc-type .d{display:block;font-size:12.5px;opacity:.65;line-height:1.35}"
      + ".olc-type .p{font-size:14px;font-weight:800;white-space:nowrap}"
      + ".olc-back{font:inherit;font-size:12px;background:none;border:0;cursor:pointer;text-decoration:underline;opacity:.6;padding:0;margin-bottom:14px}"
      + ".olc-back:hover{opacity:1}"
      + ".olc-field{margin-bottom:16px}"
      + ".olc-field label{display:block;font-size:12px;letter-spacing:.04em;font-weight:700;margin-bottom:6px}"
      + ".olc-field .hint{font-size:12.5px;opacity:.6;margin:0 0 8px;line-height:1.4}"
      + ".olc-field input,.olc-field textarea{width:100%;font:inherit;font-size:14px;padding:11px 13px;border:1.5px solid " + INK + ";background:#fff;color:" + INK + ";border-radius:7px}"
      + ".olc-field textarea{min-height:90px;resize:vertical}"
      + ".olc-radios{display:flex;gap:10px;flex-wrap:wrap}"
      + ".olc-radio{flex:1;min-width:160px;border:1.5px solid " + INK + ";border-radius:7px;padding:12px 14px;cursor:pointer;font-size:14px;font-weight:600}"
      + ".olc-radio.sel{background:rgba(249,203,12,.28);box-shadow:inset 0 0 0 2px " + INK + "}"
      + ".olc-radio input{margin-right:8px}"
      + ".olc-add{width:100%;font:inherit;font-size:14px;letter-spacing:.1em;text-transform:uppercase;font-weight:700;padding:16px;border:1.5px solid " + INK + ";border-radius:8px;background:" + INK + ";color:#fff;cursor:pointer;transition:background .12s,color .12s;margin-top:4px}"
      + ".olc-add:hover{background:" + YELLOW + ";color:" + INK + "}"
      + ".olc-add[disabled]{opacity:.6;cursor:default}"
      + ".olc-note{font-size:12px;opacity:.6;text-align:center;margin-top:10px}"
      + ".olc-msg{font-size:13px;margin-top:10px;min-height:1px;color:" + RED + "}"
      + ".olc-done{text-align:center;padding:12px 0 4px}"
      + ".olc-done .ck{display:inline-flex;align-items:center;justify-content:center;width:48px;height:48px;border-radius:50%;background:" + YELLOW + ";font-size:25px;font-weight:800;margin-bottom:12px}"
      + ".olc-done h4{margin:0 0 6px;font-size:18px;font-weight:800}"
      + ".olc-done p{margin:0;font-size:13.5px;opacity:.75;line-height:1.5}";
    var s = document.createElement("style"); s.id = "olc-style"; s.textContent = c;
    document.head.appendChild(s);
  }

  // ---- cart refresh (Horizon: dispatch cart:update with rendered sections) -
  function cartSectionIds() {
    var ids = {};
    document.querySelectorAll("cart-items-component, cart-drawer-component, cart-icon").forEach(function (el) {
      var sid = el.getAttribute("data-section-id");
      if (!sid) { var h = el.closest("[data-section-id]"); sid = h && h.getAttribute("data-section-id"); }
      if (sid) ids[sid] = 1;
    });
    return Object.keys(ids);
  }
  function refreshCart(addRes) {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var sections = (addRes && addRes.sections) || {};
      try {
        document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true,
          detail: { resource: {}, sourceId: "customize", data: { itemCount: cart.item_count, source: "customize", sections: sections } } }));
      } catch (e) {}
      ["cart:refresh", "cart:updated", "cart:change"].forEach(function (n) {
        try { document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      });
    }).catch(function () {});
  }

  function addChange(vid, properties) {
    var body = { items: [{ id: vid, quantity: 1, properties: properties }], sections: cartSectionIds().join(","), sections_url: location.pathname };
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error("add " + r.status); return r.json(); });
  }

  // ---- popup -------------------------------------------------------------
  function openPopup(ctx) {
    if (state.open) return; state.open = true;
    injectCSS();
    var ov = document.createElement("div");
    ov.className = "olc-overlay";
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add("in"); });

    function close() {
      ov.classList.remove("in");
      setTimeout(function () { ov.remove(); state.open = false; document.removeEventListener("keydown", onKey); }, 180);
    }
    function onKey(e) { if (e.key === "Escape") close(); }
    document.addEventListener("keydown", onKey);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });

    renderChooser(ov, ctx, close);
  }

  function shell(inner) {
    return '<div class="olc-modal"><button type="button" class="olc-close" aria-label="Close">&times;</button>' + inner + '</div>';
  }
  function forLine(ctx) {
    return ctx.title ? '<p class="olc-for">For: <strong>' + esc(ctx.title) + "</strong></p>" : "";
  }

  function renderChooser(ov, ctx, close) {
    // No custom changes at all on Limited Edition / Heavy pieces.
    if (isLimited(ctx)) {
      ov.innerHTML = shell(
        '<div class="olc-eyebrow">Make it yours</div>'
        + '<h3 class="olc-h">Customize this print</h3>'
        + forLine(ctx)
        + '<p class="olc-for">Custom changes aren&#39;t available on Limited Edition or Heavy pieces &mdash; these are produced exactly as designed.</p>'
      );
      ov.querySelector(".olc-close").addEventListener("click", close);
      return;
    }
    var types = [
      { key: "color", t: "Color change", d: "Recolor the art - match another print, or go custom." },
      { key: "text", t: "Text + design", d: "Add a frequency, city, flight number, or note." },
      { key: "orient", t: "Diagram orientation", d: "Flip the layout North/South if you prefer." },
      { key: "version", t: "Version - White Line or Raw Metal", d: "Get this print as a white-line or raw-metal edition." }
    ];
    ov.innerHTML = shell(
      '<div class="olc-eyebrow">Make it yours</div>'
      + '<h3 class="olc-h">Customize this print</h3>'
      + forLine(ctx)
      + '<div class="olc-types">'
      + types.map(function (x) {
          return '<button type="button" class="olc-type" data-key="' + x.key + '"><span class="tw"><span class="t">' + esc(x.t) + '</span><span class="d">' + esc(x.d) + "</span></span>"
            + '<span class="p">' + priceLabel(x.key, ctx) + "</span></button>";
        }).join("")
      + "</div>"
      + '<p class="olc-note" style="margin-top:14px">' + memberNote(ctx) + "</p>"
      + '<p class="olc-note" style="margin-top:4px">We send a proof within 24 hours - we never print until you approve.</p>'
    );
    ov.querySelector(".olc-close").addEventListener("click", close);
    ov.querySelectorAll(".olc-type").forEach(function (b) {
      b.addEventListener("click", function () { renderDetails(ov, ctx, b.dataset.key, close); });
    });
  }

  function renderDetails(ov, ctx, key, close) {
    var cfg = CHANGES[key];
    var fields = "";
    // "Which artwork" - prefilled+locked on product pages, editable elsewhere.
    if (!ctx.title) {
      fields += '<div class="olc-field"><label>Which artwork is this for?</label><input class="f-art" placeholder="e.g. DCA | Washington, DC"></div>';
    }
    if (key === "color") {
      fields += '<div class="olc-field"><label>What color change would you like?</label>'
        + '<p class="hint">Easiest: name <strong>another print to match</strong> and we will match its colors. Or describe exactly what you want - the more specific, the better.</p>'
        + '<textarea class="f-detail" placeholder="e.g. Match the BOS print  /  or: navy to forest green, keep runways white"></textarea></div>';
    } else if (key === "text") {
      fields += '<div class="olc-field"><label>What text should we add, and where?</label>'
        + '<p class="hint">Radio frequency, city name, flight number, a date - anything.</p>'
        + '<textarea class="f-detail" placeholder="e.g. Add &quot;N4521C&quot; centered below the title"></textarea></div>';
    } else if (key === "version") {
      fields += '<div class="olc-field"><label>Which version would you like?</label>'
        + '<div class="olc-radios">'
        + '<label class="olc-radio sel"><input type="radio" name="ver" value="White Line" checked>White Line</label>'
        + '<label class="olc-radio"><input type="radio" name="ver" value="Raw Metal">Raw Metal</label>'
        + "</div>"
        + '<p class="hint" style="margin-top:8px">Raw is available on metal only.</p></div>'
        + '<div class="olc-field"><label>Notes (optional)</label><textarea class="f-detail" placeholder="Anything we should know? e.g. size or material."></textarea></div>';
    } else {
      fields += '<div class="olc-field"><label>Orientation</label>'
        + '<div class="olc-radios">'
        + '<label class="olc-radio sel"><input type="radio" name="ori" value="Standard (as charted)" checked>Standard (as charted)</label>'
        + '<label class="olc-radio"><input type="radio" name="ori" value="North/South">North / South</label>'
        + "</div></div>"
        + '<div class="olc-field"><label>Notes (optional)</label><p class="hint">If there are multiple diagrams, tell us which one(s) to change.</p><textarea class="f-detail" placeholder="Which diagram(s)? Any other detail."></textarea></div>';
    }

    var plabel = priceLabel(key, ctx);
    ov.innerHTML = shell(
      '<button type="button" class="olc-back">&larr; back</button>'
      + '<div class="olc-eyebrow">' + plabel + (plabel === "Free" ? "" : " - one-time") + '</div>'
      + '<h3 class="olc-h">' + esc(cfg.label) + "</h3>"
      + forLine(ctx)
      + fields
      + '<p class="olc-note" style="margin:2px 0 10px">We&#39;ll email you a proof to approve &mdash; nothing prints until you say go.</p>'
      + '<button type="button" class="olc-add">Add to cart &mdash; ' + plabel + "</button>"
      + '<div class="olc-msg"></div>'
      + '<p class="olc-note">' + memberNote(ctx) + "</p>"
    );

    ov.querySelector(".olc-close").addEventListener("click", close);
    ov.querySelector(".olc-back").addEventListener("click", function () { renderChooser(ov, ctx, close); });
    ov.querySelectorAll(".olc-radio").forEach(function (lab) {
      lab.addEventListener("click", function () {
        ov.querySelectorAll(".olc-radio").forEach(function (l) { l.classList.remove("sel"); });
        lab.classList.add("sel");
      });
    });

    ov.querySelector(".olc-add").addEventListener("click", function () {
      var msg = ov.querySelector(".olc-msg");
      var artInput = ov.querySelector(".f-art");
      var artwork = ctx.title || (artInput ? artInput.value.trim() : "");
      var detail = (ov.querySelector(".f-detail") || {}).value || "";
      detail = detail.trim();
      var ori = (ov.querySelector('input[name="ori"]:checked') || {}).value || "";
      var ver = (ov.querySelector('input[name="ver"]:checked') || {}).value || "";

      if (!artwork) { msg.textContent = "Please tell us which artwork this is for."; return; }
      if ((key === "color" || key === "text") && !detail) { msg.textContent = "Please add a few details so we can proof it."; return; }

      var props = { "For artwork": artwork };
      if (key === "color") props["Color request"] = detail;
      else if (key === "text") props["Text to add"] = detail;
      else if (key === "version") { props["Version requested"] = ver; if (detail) props["Notes"] = detail; }
      else { props["Orientation"] = ori; if (detail) props["Notes"] = detail; }

      var btn = ov.querySelector(".olc-add");
      btn.disabled = true; btn.textContent = "Adding...";
      addChange(cfg.vid, props).then(function (res) {
        refreshCart(res);
        ov.querySelector(".olc-modal").innerHTML =
          '<div class="olc-done"><div class="ck">&#10003;</div><h4>Added to your cart</h4>'
          + "<p>Your " + esc(cfg.label.toLowerCase()) + " is on the order. We&#39;ll email a proof within 24 hours - nothing prints until you approve.</p></div>";
        setTimeout(close, 2200);
      }).catch(function () { btn.disabled = false; btn.textContent = "Try again"; msg.textContent = "Something went wrong - please try again."; });
    });
  }

  // ---- wire up the Customize buttons -------------------------------------
  // The button is full-width via the Liquid block, so it stacks cleanly under
  // Add to Cart (best for mobile) - no DOM relocation needed.
  function wire() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest(".ol-customize-btn") : null;
      if (!btn) return;
      e.preventDefault();
      openPopup({
        title: btn.getAttribute("data-product-title") || "",
        tags: btn.getAttribute("data-product-tags") || "",
        handle: btn.getAttribute("data-product-handle") || "",
        member: btn.getAttribute("data-member") || ""
      });
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
})();